import { motion } from "framer-motion";
import { Eye, Target } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { useSite } from "@/context/SiteContentContext";
import { Reveal, SectionTag } from "./Reveal";
import ParticleField from "./ParticleField";

export default function About() {
  const { t, lang } = useLang();
  const { settings: s } = useSite();
  const title = s[`about_title_${lang}`] || t.about.title;
  const body = s[`about_body_${lang}`] || t.about.body;
  const vision = {
    title: s[`about_vision_title_${lang}`] || t.about.vision.title,
    body: s[`about_vision_body_${lang}`] || t.about.vision.body,
  };
  const mission = {
    title: s[`about_mission_title_${lang}`] || t.about.mission.title,
    body: s[`about_mission_body_${lang}`] || t.about.mission.body,
  };
  return (
    <section id="about" className="relative section-pad overflow-hidden" data-testid="about-section">
      <ParticleField className="opacity-40" density={35} />
      <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 80% 20%, rgba(10,30,78,0.5), transparent 60%)" }} />
      <div className="relative z-10 mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <SectionTag>{t.about.tag}</SectionTag>
        </Reveal>
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 mt-6 items-start">
          <Reveal>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight mb-6">{title}</h2>
            <p className="text-slate-400 leading-relaxed text-base sm:text-lg">{body}</p>
          </Reveal>

          <div className="grid gap-6">
            {[{ icon: Eye, d: vision }, { icon: Target, d: mission }].map((item, i) => (
              <Reveal key={i} delay={i * 0.12}>
                <motion.div whileHover={{ x: 6 }} className="card-surface rounded-2xl p-7">
                  <div className="flex items-center gap-4 mb-3">
                    <div className="h-12 w-12 rounded-2xl grid place-items-center shrink-0" style={{ background: "rgba(0,242,96,0.12)" }}>
                      <item.icon size={22} className="text-primary" />
                    </div>
                    <h3 className="text-xl font-bold">{item.d.title}</h3>
                  </div>
                  <p className="text-slate-400 leading-relaxed">{item.d.body}</p>
                </motion.div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
